<footer
  class="py-4 text-white"
  style="background-color: var(--bs-primary)"
  role="contentinfo"
>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-6 text-center text-md-start mb-2 mb-md-0">
        <p class="mb-0 text-white">
          © {{ currentYear }} Cooxupé - Sismet Web - Versão 1.0.0-beta.1
        </p>
      </div>
      <div class="col-md-6 text-center text-md-end">
        <p class="mb-0">
          <a
            href="mailto:geoprocessamento@cooxupe.com.br"
            class="text-white text-decoration-none"
            aria-label="Enviar email para geoprocessamento@cooxupe.com.br"
          >
            <i class="fa-solid fa-envelope me-2" aria-hidden="true"></i>
            geoprocessamento@cooxupe.com.br
          </a>
        </p>
      </div>
    </div>
  </div>
</footer>
